import React from "react";
import { connect, ConnectedProps } from 'react-redux'

import { reduxActions } from '../../../store'

import { Prompt } from 'react-router';
import { withRouter, RouteComponentProps, matchPath } from 'react-router-dom'
import { Text, Callout, ChoiceGroup, CommandBar, DefaultButton, Dialog, DialogFooter, DialogType, DirectionalHint, IButtonProps, IButtonStyles, IChoiceGroup, IChoiceGroupOption, IChoiceGroupOptionStyles, ICommandBarItemProps, ICommandBarStyles, IDialogContentProps, IModalProps, IModalStyles, Label, mergeStyleSets, MessageBar, MessageBarType, PrimaryButton, FontWeights, FocusZone, Stack, FocusZoneTabbableElements, FontIcon, mergeStyles } from "@fluentui/react";
import { Indici_FormMode, LabelOrientation, Protocol_State, Protocol_Type, RoleContext, Visibilita_ViewMode, Visibility_Type, Wizard_Mode, Wizard_Mode_Path } from '../../../shared/enums';

import { Steps } from 'primereact/steps';

import { RootState } from "../../../store";
import { ScrollPanel } from "primereact/scrollpanel";
import LabelPosition from "./LabelPosition/LabelPosition";
import { ICreateAllocatedProtocolRequest, IField, IFile, ILabelInfo, IProtocol, ITitolario, IUor } from "../../../shared/interfaces";
import UploadFiles from "./UploadFiles/UploadFiles";
import FilesList from "./UploadFiles/FilesList";
import fieldsService from '../../../services/fields.service';
import CustomCommandBarButton from "../../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton";
import protocolsService from "../../../services/protocols.service";
import RippleLoader from "../../Loader/RippleLoader/RippleLoader";
import Visibilita from "../Visibilita/Visibilita";
import CircleLoader from "../../Loader/CircleLoader/CircleLoader";

import { myTheme } from '../../../assets/styles/my-theme'
import DynamicForm from "../../DynamicForm/DynamicForm";
import { subject, Unsubscribe } from "@casl/ability";
import abilityBuild from '../../../shared/CASL/appAbility';
import { checkRoles } from "../../../hoc/CheckRoles";
import AppUtilities from "../../../shared/Utilities/appUtilities";
import axios from "axios";
import PdfViewer from "../../PdfViewer/PdfViewer";
import filesService from "../../../services/files.service";
import FilingPlanTree from "../../FilingPlan/FilingPlanTree";
import { toastRef } from '../../Layout/Layout';
import { ProtocolWizardReduxState } from "../../../store/create-protocol-wizard/types";
import usersService from "../../../services/users.service";
import peripheralService from "../../../services/peripheral.service";
import PrintLabel from "./UploadFiles/PrintLabel/PrintLabel";

const { palette } = myTheme;

const queryString = require('query-string');

const overflowProps: IButtonProps = { ariaLabel: 'More commands' };

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' },
    // primarySet: {
    //     '& .ms-OverflowSet-item:first-of-type': {
    //         display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
    //     }
    // },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
        }
    }
};

const forwardButtonStyles: Partial<IButtonStyles> = {
    flexContainer: {
        flexDirection: 'row-reverse'
    }
}


const choiceGroupOptionStyles: Partial<IChoiceGroupOptionStyles> = {
    labelWrapper: {
        maxWidth: 92
    },
    field: {
        '&.is-checked': {
            color: palette.themePrimary
        },
        '&.is-checked:hover .ms-ChoiceFieldLabel': {
            color: palette.themePrimary
        },
    },
}

const visibilitaDialogStyles: Partial<IModalStyles> = {
    main: {
        '@media(min-width: 480px)': {
            width: '100%',
            maxWidth: 450
        }
    }
}


const visibilitaModalProps: IModalProps = {
    isBlocking: false,
    styles: visibilitaDialogStyles,
    className: "visibilita-dialog-wizard"
};

const modalStyles: Partial<IModalStyles> = {
    main: {
        '@media(min-width: 480px)': {
            width: '100%',
            maxWidth: 400
        }
    }
}

const modalProps: IModalProps = {
    isBlocking: false,
    styles: modalStyles,
};

const iconClass = mergeStyles({
    fontSize: 20,
    height: 20,
    width: 20,
});

const styles = mergeStyleSets({

    callout: {
        width: 320,
        padding: '20px 24px',
    },
    title: {
        marginBottom: 12,
        fontWeight: FontWeights.semilight,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 20,
    },
    alertIcon: [{
        color: palette.themePrimary,
    },
        iconClass]
});

const acquiredProtocolSteps = [
    {
        label: 'Files',

    },
    {
        label: 'Indici',

    }
]
const generalProtocolSteps = [
    {
        label: 'Files',

    },
    {
        label: 'Indici',

    },
    {
        label: 'Posizione etichetta',

    }
]

const mapState = (state: RootState) => ({
    currentProtocolWizardState: state.protocolWizardReducer,
    currentWizardMode: state.protocolWizardReducer.wizardMode,
    currentProtocol: state.protocolWizardReducer.protocol,
    currentLabelInfo: state.protocolWizardReducer.labelInfo,
    currentPageScaledHeight: state.protocolWizardReducer.pageScaledHeight,
    docInFields: state.protocolWizardReducer.docInFields,
    docOutFields: state.protocolWizardReducer.docOutFields,
    docInternalFields: state.protocolWizardReducer.docInternalFields,
    stepIndex: state.protocolWizardReducer.stepIndex,

    currentUor: state.sessionReducer.currentUor,
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    arxeiaConfigurations: state.sessionReducer.arxeiaConfigurations,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
})
const mapDispatch = {
    setInitialState: (wizardMode: Wizard_Mode) => (reduxActions.protocolWizardActions.setInitialState(wizardMode)),
    labelDirectionToggle: () => (reduxActions.protocolWizardActions.labelDirectionToggle()),
    nextStepIndex: () => (reduxActions.protocolWizardActions.nextStepIndex()),
    previousStepIndex: () => (reduxActions.protocolWizardActions.previousStepIndex()),
    setProtocol: (protocol: IProtocol) => (reduxActions.protocolWizardActions.setProtocol(protocol)),
    setDocumentFile: (documentFile: IFile | undefined) => (reduxActions.protocolWizardActions.setDocumentFile(documentFile)),
    setAttachments: (attachments: IFile[]) => (reduxActions.protocolWizardActions.setAttachments(attachments)),
    updateProtocolWizardState: (partialProtocolWizardState: Partial<ProtocolWizardReduxState>) => (reduxActions.protocolWizardActions.updateProtocolWizardState(partialProtocolWizardState)),
    setStepIndex: (stepIndex: number) => (reduxActions.protocolWizardActions.setStepIndex(stepIndex)),
    setProtocolWizardTouched: () => (reduxActions.protocolWizardActions.setProtocolWizardTouched()),
    updateAttachment: (attachment: IFile) => (reduxActions.protocolWizardActions.updateAttachment(attachment)),
    updateSession: (session) => (reduxActions.sessionActions.updateSession(session)),
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>


export interface ProtocolWizardProps {
}
export interface ProtocolWizardState {
    stepItems: any[],
    documentTypeOptions: IChoiceGroupOption[],
    commandBarItems: ICommandBarItemProps[],
    farItems: ICommandBarItemProps[]
    shouldBlockNavigation: boolean
    targetUpload: string
    confirmDialogIsOpen: boolean,
    confirmDialogContentProps: IDialogContentProps,
    confirmDialogModalProps: IModalProps,
    confirmDialogSubmitFunction: Function
    setVisibilitaDialogIsOpen: boolean,
    setVisibilitaDialogContentProps: IDialogContentProps,
    setAlertDialogContentProps: IDialogContentProps
    setVisibilitaDialogSubmitFunction: Function,
    isLoadingProtocol: boolean,
    showActionsLoader: boolean
    showIndiciLoader: boolean,
    showMessageBar: boolean
    messageBarType: MessageBarType,
    messageBarText: string,
    titolarioRequired: boolean,
    titolarioTouched: boolean,
    titolarioValid: boolean,
    selectUorDialogIsOpen: boolean,
    selectUorDialogContentProps: IDialogContentProps,
    selectUorChoiceGroupOptions: IChoiceGroupOption[],
    isDocumentChanged: boolean
    selectedPrinterName: string | undefined

}
type Props = ProtocolWizardProps & RouteComponentProps & PropsFromRedux



class ProtocolWizard extends React.Component<Props, ProtocolWizardState> {
    choiceGroupRef = React.createRef<IChoiceGroup>();
    unsubscribeFromAbility: Unsubscribe = () => { };

    state: ProtocolWizardState = {
        isLoadingProtocol: true,
        stepItems: generalProtocolSteps,
        documentTypeOptions: [
            { key: Protocol_Type[Protocol_Type.DocumentoInEntrata], text: 'In entrata', iconProps: { iconName: 'PageCheckedIn' }, styles: choiceGroupOptionStyles },
            { key: Protocol_Type[Protocol_Type.DocumentoInUscita], text: 'In uscita', iconProps: { iconName: 'PageCheckedOut' }, styles: choiceGroupOptionStyles },
            { key: Protocol_Type[Protocol_Type.DocumentoInterno], text: 'Interno', iconProps: { iconName: 'PeopleRepeat' }, styles: choiceGroupOptionStyles },
        ],
        commandBarItems: [],
        farItems: [
            {
                key: 'indietro',

                commandBarButtonAs: () => (
                    <DefaultButton
                        primary
                        className='step-navigation-button'
                        text="Indietro"
                        iconProps={{ iconName: 'Back' }}
                        // By default, the ContextualMenu is re-created each time it's shown and destroyed when closed.
                        // Uncomment the next line to hide the ContextualMenu but persist it in the DOM instead.
                        // persistMenu={true}
                        allowDisabledFocus
                        disabled={this.props.stepIndex === 0}
                        onClick={this.onBackButtonClick}


                    />
                )
            },
            {
                key: 'avanti',
                commandBarButtonAs: () => (
                    <DefaultButton
                        primary
                        className='step-navigation-button'
                        text="Avanti"
                        styles={forwardButtonStyles}
                        iconProps={{ iconName: 'Forward' }}
                        // By default, the ContextualMenu is re-created each time it's shown and destroyed when closed.
                        // Uncomment the next line to hide the ContextualMenu but persist it in the DOM instead.
                        // persistMenu={true}
                        allowDisabledFocus
                        disabled={this.props.stepIndex === this.state.stepItems.length - 1}
                        onClick={this.onForwardButtonClick}

                    />
                )
            }
        ],
        shouldBlockNavigation: false,
        targetUpload: 'documento',
        confirmDialogIsOpen: false,
        confirmDialogContentProps: {},
        confirmDialogModalProps: {},
        confirmDialogSubmitFunction: () => { },
        setVisibilitaDialogIsOpen: false,
        setVisibilitaDialogContentProps: {},
        setAlertDialogContentProps: {},
        setVisibilitaDialogSubmitFunction: () => { },
        showActionsLoader: false,
        showIndiciLoader: false,
        showMessageBar: false,
        messageBarType: MessageBarType.info,
        messageBarText: "",
        titolarioRequired: false,
        titolarioTouched: false,
        titolarioValid: true,
        selectUorDialogIsOpen: false,
        selectUorDialogContentProps: {},
        selectUorChoiceGroupOptions: [],
        isDocumentChanged: false,
        selectedPrinterName: undefined
    }


    componentDidMount() {
        let wizardMode = this.getProtocolWizardMode();
        this.props.setInitialState(wizardMode);
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            this.updateCommandBarItems(wizardMode);
            setTimeout(() => this.checkProtocolWizardAccess(wizardMode), 100);
        });
    }


    componentDidUpdate(oldProps, oldState) {
        let wizardMode = this.props.currentWizardMode;

        if (!this.state.showIndiciLoader && this.props.currentAoo && this.props.currentUor && this.props.stepIndex === 0 && this.props.currentProtocol.tipoProtocollo !== Protocol_Type.Undefined && this.props.currentProtocol.fields?.length === 0) {
            this.setState({ showIndiciLoader: true })
            fieldsService.getFieldsByType(this.props.currentAoo.id, this.props.currentUor.id!, this.props.currentProtocol.tipoProtocollo!)
                .then(fields => {
                    let _fields: IField[] = [];

                    fields?.forEach(f => {
                        if (!f.system && !f.readonly && f.internalName !== 'Title') {
                            let _field = { ...f };
                            _field.valid = true;
                            _field.touched = false;
                            _fields.push(_field);

                        }

                    });

                    this.props.updateProtocolWizardState(
                        {
                            protocol: { ...this.props.currentProtocol, fields: _fields },
                            docInFields: _fields,
                        });

                    this.setState({ showIndiciLoader: false })
                })
        }


        if (oldProps.stepIndex !== this.props.stepIndex) {
            this.updateCommandBarItems(wizardMode);
        }

        if (oldProps.currentProtocol !== this.props.currentProtocol && this.props.currentProtocol && this.props.currentUor) {
            this.updateCommandBarItems(wizardMode);
            let currentUor = { ...this.props.currentUor };
            let visibilita = this.props.currentProtocol.visibilita ? [...this.props.currentProtocol.visibilita] : [];
            if (visibilita && visibilita.findIndex(v => v.uor.id === currentUor.id) < 0) {
                visibilita.push({ uor: currentUor, tipologia: Visibility_Type.Proprietario });
                this.props.setProtocol({ visibilita: visibilita });

            }
            this.setState({ shouldBlockNavigation: true })
            //////// Previene la chiusura del tab del browser e il refresh della pagina
            window.onbeforeunload = (event) => {
                const e = event || window.event;
                e.preventDefault();
                if (e) {
                    e.returnValue = true;
                }
                return true;
            };
            //////// 
        }
        if (this.props.currentProtocol && oldProps.currentProtocol.fields !== this.props.currentProtocol.fields) {
            //let titolarioField = this.props.currentProtocol.fields?.find(el => el.internalName === 'Titolario');
            //if (titolarioField) {
            //    this.setState({ titolarioRequired: titolarioField.required, titolarioTouched: false });
            //}
            //else {
            //    this.setState({ titolarioRequired: false, titolarioTouched: false });
            //}
        }

    }

    componentWillUnmount() {
        let { wizardMode } = this.props.currentProtocolWizardState
        this.props.setInitialState(Wizard_Mode.Create);
        window.onbeforeunload = null;
        this.unsubscribeFromAbility();

    }

    getProtocolWizardMode = (): Wizard_Mode => {
        const { location } = this.props;

        const wizardModesArray = Object.values(Wizard_Mode);

        let wizardMode = Wizard_Mode.Create;
        // Use forEach on the array
        wizardModesArray.forEach(el => {
            if (isNaN(Number(el))) {
                return;
            }
            let mode = Number(el);
            if (matchPath(location.pathname, { path: Wizard_Mode_Path.get(mode), exact: true })) {
                wizardMode = mode;
            }
        });

        return wizardMode
    }


    checkProtocolWizardAccess = (wizardMode: Wizard_Mode) => {
        if (this.props.currentAoo) {
            let { currentAoo, currentUser, match, location, history } = this.props;
            const parsedQueryString = queryString.parse(this.props.location.search);
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            /// se nell'url c'è il parametro uorId che specifica con quale uor accedere al protocollo
            ///     l'utente può creare protocolli nella uor che sta navigando?
            ///     - no: viene eseguita una redirect alla pagina unauthorized
            ///     - si: faccio get visibilità
            ///          la uor che sto navigando è in visibilità?
            ///           - si: procedo con getprotocol....
            ///           - no: in visibilità c'è almeno una UOR associata a current user?
            ///                  se in visibilità c'è una sola UOR associata a current user, allora chiamo getProtocol passando l'uor in visibilità
            ///                  se in visibilità ci sono più UOR associate a current user, allora viene mostrata la dialog per scegliere con quale UOR accedere
            ///                  se in visibilità NON ci sono UOR associate a current user e l'utente corrente è un supervisore, allora procedo con getprotocol passando null come UOR....
            ///                  altrimeti viene eseguita una redirect alla pagina unauthorized
            /// se nell'url NON c'è il parametro uorId
            ///     ricavo tutte le uor in cui l'utente è operatore
            ///     se l'utente è operatore in una sola UOR, allora viene inserito il parametro uorId nell'url e aggiornata la pagina
            ///     se l'utente è operatore in più UOR, allora viene mostrata la dialog per scegliere in quale UOR creare il protocollo
            ///     se NON ci sono UOR in cui l'utente corrente è operatore  viene eseguita una redirect alla pagina unauthorized

            if (uorId) {
                let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: uorId } }] };
                if (abilityBuild.cannot('create', subject('IProtocol', prot))) {
                    this.props.history.push({ pathname: '/unauthorized' });
                }
                else if (match.params['id']) {

                    protocolsService.getUserVisibilitaForProtocol(currentAoo.id, match.params['id'])
                        .then(userVisibilita => {

                            if (userVisibilita && userVisibilita.findIndex(el => el.uor.id === uorId) >= 0) {
                                this.getProtocol(wizardMode, uorId);
                            }
                            else if (userVisibilita && userVisibilita.length === 1) {
                                let uorId = userVisibilita[0].uor.id;
                                this.getProtocol(wizardMode, uorId);
                            }
                            else if (userVisibilita && userVisibilita.length > 1) {
                                let options: IChoiceGroupOption[] = userVisibilita.map((el, index) => {
                                    return { key: index.toString(), text: el.uor.nome!, uorId: el.uor.id, tipologia: el.tipologia };
                                });

                                this.setState({
                                    selectUorDialogIsOpen: true,
                                    selectUorDialogContentProps: {
                                        type: DialogType.largeHeader,
                                        title: 'Seleziona una UOR',
                                        subText: 'Con quale UOR accedere al protocollo di origine?',
                                    },
                                    selectUorChoiceGroupOptions: options
                                });
                            }
                            else if ((!userVisibilita || userVisibilita.length === 0) && usersService.userIsSupervisore(currentUser!, currentAoo.id)) {
                                this.getProtocol(wizardMode, undefined);
                            }
                            else {
                                history.push({ pathname: '/unauthorized' });
                            }
                        });
                }
                else {
                    this.setState({ isLoadingProtocol: false });
                }
            }
            else {
                const userUor = currentUser?.ruoliUorContext.reduce((a: IUor[], o) => (o.uor && o.uor.aooId === currentAoo.id && o.ruolo && o.ruolo.nome === "Operatore" && a.push(o.uor), a), []) ?? [];


                if (userUor.length === 1) {
                    let { url } = match;
                    let uorId = userUor[0].id;
                    const parsedQueryString = queryString.parse(location.search);
                    parsedQueryString.uorId = uorId;
                    const newQueryString = queryString.stringify(parsedQueryString);

                    history.replace({ pathname: url, search: newQueryString });
                    toastRef.current?.show({ severity: 'info', summary: 'Cambio UOR', detail: `Sei passato alla UOR: ${userUor[0].nome}`, life: 5000 });

                }
                else if (userUor.length > 1) {
                    let options: IChoiceGroupOption[] = userUor.map((el, index) => {
                        return { key: index.toString(), text: el.nome!, uorId: el.id };
                    });

                    this.setState({
                        selectUorDialogIsOpen: true,
                        selectUorDialogContentProps: {
                            type: DialogType.largeHeader,
                            title: 'Seleziona una UOR',
                            subText: 'In quale UOR vuoi creare il nuovo protocollo?',
                        },
                        selectUorChoiceGroupOptions: options
                    });
                }
                else {
                    history.push({ pathname: '/unauthorized' });
                }

            }
        }
    }

    getProtocol(wizardMode: Wizard_Mode, uorId: number | undefined) {
        if (this.props.currentAoo) {
            this.setState({ isLoadingProtocol: true });

            let { currentAoo, currentUser, match } = this.props;



            const getProtocol = protocolsService
                .getProtocol(currentAoo.id, uorId, match.params['id']);


            let requestArray = [getProtocol];
            if (wizardMode !== Wizard_Mode.CreateFrom && wizardMode !== Wizard_Mode.Reload && wizardMode !== Wizard_Mode.Allocated) {
                const getProtocolBase64String = protocolsService
                    .getProtocolBase64String(currentAoo.id, uorId, match.params['id'])
                    .catch(error => {
                        if (axios.isCancel(error)) {
                            //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                            console.log(error.message);
                        }
                        else if (error.response.status === 404) {
                            this.props.setDocumentFile(undefined);

                            //le bozze possonon non avere il documento, quindi non è un errore
                        }
                        else if (!error.isErrorShown) {
                            toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Documento non recuperato`, life: 5000 });
                        } else {
                            throw error;
                        }
                    });

                requestArray.push(getProtocolBase64String)
            }


            axios.all(requestArray).then(axios.spread((...responses) => {
                let newProtocol: IProtocol = responses[0]
                // ricavo le uor in cui l'utente corrente ha almeno un ruolo
                const userUor = currentUser?.ruoliUorContext.reduce((a: IUor[], o) => (o.uor && o.uor.aooId === currentAoo.id && a.push(o.uor), a), []) ?? [];
                // ricavo le uor che sono nella visibilità di newProtocol e in cui l'utente corrente ha almeno un ruolo
                const userUorInVisibilita = newProtocol.visibilita?.reduce((a: IUor[], o) => (userUor.findIndex(el => el.id === o.uor.id) >= 0 && a.push(o.uor), a), []) ?? [];

                // se l'utente appartiene almeno ad una uor tra quelle in visibilità del protocollo, allora può accedere al protocollo
                if (userUorInVisibilita.length <= 0 && !usersService.userIsSupervisore(currentUser!, currentAoo.id)) {
                    this.props.history.push({ pathname: '/unauthorized' });
                }

                let _stepItems = [...generalProtocolSteps];
                let { fields } = newProtocol;
                let titolarioField = fields?.find(el => el.internalName === 'Titolario');

                let _fields = AppUtilities.FilterAndFixFieldsByWizardMode(wizardMode, fields!);
                newProtocol.fields = [..._fields];
                newProtocol = { ...newProtocol, documentFile: undefined };

                let partialProtocolWizardState: Partial<ProtocolWizardReduxState> = { protocol: newProtocol };
                switch (newProtocol.tipoProtocollo) {
                    case Protocol_Type.DocumentoInEntrata:
                        partialProtocolWizardState = { ...partialProtocolWizardState, docInFields: _fields };
                        break;

                    case Protocol_Type.DocumentoInUscita:
                        partialProtocolWizardState = { ...partialProtocolWizardState, docOutFields: _fields };
                        break;

                    case Protocol_Type.DocumentoInterno:
                        partialProtocolWizardState = { ...partialProtocolWizardState, docInternalFields: _fields };
                        break;

                }
                this.props.updateProtocolWizardState(partialProtocolWizardState);



                let newAttachments: IFile[] = [];
                switch (wizardMode) {
                    case Wizard_Mode.CreateFrom:

                        /// devo forzare i valori undefined altrimenti restano quelli del protocollo originale
                        let _protocol = {
                            ...newProtocol,
                            attachments: [],
                            hasAttachments: false,
                            annoProtocollo: undefined,
                            dataProtocollo: undefined,
                            documentFile: undefined,
                            hasNotes: undefined,
                            id: undefined,
                            idPdVConservazione: undefined,
                            numeroProtocollo: undefined,
                            statoConservazione: undefined,
                            utenteModifica: undefined

                        };
                        this.props.setProtocol({ ..._protocol });

                        break;

                    case Wizard_Mode.Reload:
                        this.setAttachments(newProtocol);


                        partialProtocolWizardState = { ...partialProtocolWizardState, protocol: { ...newProtocol } };
                        break;

                    case Wizard_Mode.Acquired:

                        _stepItems = [...acquiredProtocolSteps];

                        const fileResultAcquired = responses[1] as IFile;
                        this.setDocumentFile(fileResultAcquired, newProtocol);

                        this.setAttachments(newProtocol);
                        break;
                    case Wizard_Mode.Allocated:

                        _stepItems = [...acquiredProtocolSteps];
                        let protocol = {
                            ...newProtocol,
                            documentFile: undefined
                        };


                        this.props.setProtocol(protocol);
                        break;
                    case Wizard_Mode.Create:
                    case Wizard_Mode.Edit:
                        const fileResult = responses[1] as IFile;
                        this.setDocumentFile(fileResult, newProtocol);

                        this.setAttachments(newProtocol);

                        break;

                }

                if (titolarioField) {
                    this.setState({
                        titolarioRequired: titolarioField.required,
                        titolarioTouched: false,
                        isLoadingProtocol: false,
                        stepItems: _stepItems
                    });
                }
                else {
                    this.setState({
                        titolarioRequired: false,
                        titolarioTouched: false,
                        isLoadingProtocol: false,
                        stepItems: _stepItems
                    });
                }


            })).catch(errors => {
                this.setState({ isLoadingProtocol: false });

                throw errors
                // react on errors.
            })

        }
    }

    setAttachments = (newProtocol: IProtocol) => {

        let attachments = newProtocol.attachments ? [...newProtocol.attachments] : [];

        let newAttachments: IFile[] = attachments.map(el => {
            let extension = AppUtilities.getExtensionFromFilename(el.fileName);
            let file: IFile = {
                ...el,
                loading: false, // el.docBase64String ? false : true,
                extension: extension,
                enabled: true,
            };
            return file;
        });
        newAttachments = newAttachments.sort(AppUtilities.compareFileEnableBeforeDisabled);

        this.props.setAttachments([...newAttachments]);
    }


    // Click sul button della commandbar
    salvaBozzaHandler = async (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        /// faccio il check di validità del wizard considerando lo stato che raggiungerà il protocollo con l'operazione
        let futureState = this.props.currentProtocol.statoProtocollo ?? Protocol_State.InCreazione;
        if (this.checkProtocolWizardValidity(futureState)) {

            let protocollo: IProtocol = { ...this.props.currentProtocol };
            protocollo.statoProtocollo = futureState;


            //Forzo lo svuotamento della visibilità del protocollo
            let currentUor = { ...this.props.currentUor };
            let visibilita = [{ uor: currentUor, tipologia: Visibility_Type.Proprietario }];
            protocollo.visibilita = visibilita;

            // attendo che l'aggiornamento dello stato sia completo (richiede che il metodo chiamante sia async)
            await this.props.updateProtocolWizardState({ protocol: protocollo });


            let { wizardMode } = this.props.currentProtocolWizardState;
            switch (wizardMode) {
                case Wizard_Mode.Create:
                case Wizard_Mode.CreateFrom:
                    this.createDraft();
                    break;
                case Wizard_Mode.Edit:
                    this.updateDraft();
                    break;

            }

        }
    }
    // Click sul button della commandbar
    deleteDraftHandler = () => {
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: `Vuoi eliminare la bozza?`,
            },
            confirmDialogSubmitFunction: () => { this.deleteDraftConfirmDialogSubmit() }
        });
    }
    deleteDraftConfirmDialogSubmit = () => {
        if (this.props.currentAoo && this.props.currentUor && this.props.currentProtocol) {
            let draft: IProtocol = { ...this.props.currentProtocol };

            if (draft.id) {
                this.setState({ confirmDialogIsOpen: false, isLoadingProtocol: true, shouldBlockNavigation: false })
                protocolsService.deleteDraft(this.props.currentAoo.id, this.props.currentUor.id!, draft.id)
                    .then(result => {
                        toastRef.current?.show({
                            severity: 'info',
                            summary: "Operazione completata",
                            detail: 'Bozza eliminata correttamente',
                            life: 5000
                        })
                        this.props.history.push({ pathname: `/${this.props.currentAoo!.id}/drafts`, search: this.props.location.search })
                    })
                    .catch(error => {
                        if (!error.isErrorShown) {
                            toastRef.current?.show({
                                severity: 'error',
                                summary: "Attenzione",
                                detail: 'Non \u00e8 stato possibile eliminare la bozza',
                                life: 5000
                            });
                        }
                    })
                    .finally(() => {
                        this.setState({ isLoadingProtocol: false })
                    });
            }
        }
    }
    // Click sul button della commandbar
    protocollaDocumentoHandler = async (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (this.props.currentAoo && this.props.currentProtocol) {
            let { currentAoo, currentProtocol, currentUor } = this.props;

            /// faccio il check di validità del wizard considerando lo stato che raggiungerà il protocollo con l'operazione
            let futureState = Protocol_State.Protocollato;

            if (this.checkProtocolWizardValidity(futureState)) {

                let { attachments, documentFile, ...submitProtocol } = currentProtocol;
                if (submitProtocol.fields) {
                    let fixedFields = AppUtilities.fixFieldsInternalValueForCreateAndUpdateProtocol([...submitProtocol.fields], true);
                    submitProtocol.fields = fixedFields;
                }

                if (this.props.currentProtocolWizardState.wizardMode !== Wizard_Mode.CreateFrom) {
                    protocolsService.getProtocolVisibilityFromForwardRules(currentAoo.id, submitProtocol)
                        .then(async result => {

                            const parsedQueryString = queryString.parse(this.props.location.search);
                            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

                            let updatedProtocol = { ...currentProtocol };

                            updatedProtocol.visibilita = [...result];
                            // attendo che l'aggiornamento dello stato sia completo (richiede che il metodo chiamante sia async)
                            await this.props.updateProtocolWizardState({ protocol: updatedProtocol });

                            this.setState({
                                setVisibilitaDialogIsOpen: true,
                                setVisibilitaDialogContentProps: {
                                    type: DialogType.largeHeader,
                                    title: 'Visibilità',
                                    subText: 'Scegli la visibilità.',
                                },
                                setVisibilitaDialogSubmitFunction: () => { this.setVisibilitaConfirmDialogSubmit(futureState) }

                            })

                        },
                            error => {
                                this.setState({
                                    showActionsLoader: false,
                                    showMessageBar: true,
                                    messageBarType: MessageBarType.error,
                                    messageBarText: 'Errore nella creazione del protocollo'
                                })
                            });
                }
                else {


                    let updatedProtocol = { ...currentProtocol };

                    let newVisibilita = [...updatedProtocol.visibilita!];

                    /// rimuovo il vecchio proprietario e tutta la visibilità associata alla uor corrente che diventerà proprietaria
                    newVisibilita = newVisibilita.filter(el => el.tipologia !== Visibility_Type.Proprietario && el.uor.id !== currentUor!.id)

                    newVisibilita.push({ tipologia: Visibility_Type.Proprietario, uor: currentUor! })


                    updatedProtocol.visibilita = [...newVisibilita];
                    // attendo che l'aggiornamento dello stato sia completo (richiede che il metodo chiamante sia async)
                    await this.props.updateProtocolWizardState({ protocol: updatedProtocol });



                    this.setState({
                        setVisibilitaDialogIsOpen: true,
                        setVisibilitaDialogContentProps: {
                            type: DialogType.largeHeader,
                            title: 'Visibilità',
                            subText: 'Scegli la visibilità.',
                        },
                        setVisibilitaDialogSubmitFunction: () => { this.setVisibilitaConfirmDialogSubmit(futureState) }

                    })
                }
            }
        }
    }

    // Click su conferma del dialog per la selezione della visibilità
    setVisibilitaConfirmDialogSubmit = async (futureState) => {

        let protocollo: IProtocol = { ...this.props.currentProtocol };

        let filteredVisibilita = this.props.currentProtocol.visibilita?.filter(v => v.tipologia !== Visibility_Type.Proprietario && v.tipologia !== Visibility_Type.Visibilita);


        let subTextMessage = protocollo.statoProtocollo === Protocol_State.Acquisito || Protocol_State.Allocato ? 'Vuoi protocollare il documento?' : 'Vuoi generare un nuovo numero di protocollo?';

        if (abilityBuild.can('use', subject('IFeature', { key: 'AlertVisibilitaMancante', enabled: true }))
            && filteredVisibilita?.length === 0) {


            this.setState({
                confirmDialogIsOpen: true,
                confirmDialogModalProps: visibilitaModalProps,
                confirmDialogContentProps: {
                    type: DialogType.largeHeader,
                    title: 'Attenzione!',
                    children:
                        <React.Fragment>
                            <div className="flex flex-row align-items-center">
                                <FontIcon aria-label="Warning" iconName="Warning" className={styles.alertIcon} />
                                <Text>Il protocollo non è stato assegnato a nessuna UOR.</Text>
                            </div>
                            <Text>{subTextMessage}</Text>
                        </React.Fragment>

                },
                confirmDialogSubmitFunction: () => { this.confirmVisibilitaChoiceAndProtocolla(futureState) }
            })



        } else {

            this.setState({ setVisibilitaDialogIsOpen: false });

            // attendo che l'aggiornamento dello stato sia completo (richiede che il metodo chiamante sia async)
            await this.props.updateProtocolWizardState({ protocol: protocollo });

            if (this.checkProtocolWizardValidity(futureState)) {

                this.setState({
                    confirmDialogIsOpen: true,
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Conferma',
                        closeButtonAriaLabel: 'Close',
                        subText: subTextMessage,
                    },
                    confirmDialogSubmitFunction: () => { this.protocollaDocumentoConfirmDialogSubmit() }
                })
            }
        }
    }


    confirmVisibilitaChoiceAndProtocolla = async (futureState) => {

        let protocollo: IProtocol = { ...this.props.currentProtocol };
        this.setState({ setVisibilitaDialogIsOpen: false, confirmDialogIsOpen: false });

        // attendo che l'aggiornamento dello stato sia completo (richiede che il metodo chiamante sia async)
        await this.props.updateProtocolWizardState({ protocol: protocollo });

        if (this.checkProtocolWizardValidity(futureState)) {
            this.protocollaDocumentoConfirmDialogSubmit();
        }
    }

    // Click su conferma del confirm dialog
    protocollaDocumentoConfirmDialogSubmit = () => {

        this.setState({ confirmDialogIsOpen: false })
        this.createProtocol(Protocol_State.Protocollato);
    }

    // Click sul button della commandbar
    acquisisciDocumentoHandler = async (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        //Setto la variabile futureState per gestire la scelta della modale
        let futureState = Protocol_State.Acquisito;

        if (this.checkProtocolWizardValidity(futureState)) {

            let protocollo: IProtocol = { ...this.props.currentProtocol };
            let subTextMessage = protocollo.statoProtocollo === Protocol_State.Acquisito || Protocol_State.Allocato ? 'Vuoi protocollare il documento?' : 'Vuoi generare un nuovo numero di protocollo?';

            this.setState({
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: subTextMessage,
                },
                confirmDialogSubmitFunction: async (ev: any) => { this.acquisisciDocumentoConfirmDialogSubmit() }
            })
        }
    }
    acquisisciDocumentoConfirmDialogSubmit = async () => {


        let protocollo: IProtocol = { ...this.props.currentProtocol };

        //Forzo lo svuotamento della visibilità del protocollo
        let currentUor = { ...this.props.currentUor };
        let visibilita = [{ uor: currentUor, tipologia: Visibility_Type.Proprietario }];
        protocollo.visibilita = visibilita;

        // attendo che l'aggiornamento dello stato sia completo (richiede che il metodo chiamante sia async)
        await this.props.updateProtocolWizardState({ protocol: protocollo });

        this.setState({ confirmDialogIsOpen: false })
        this.createProtocol(Protocol_State.Acquisito);
    }

    // Click sul button della commandbar
    allocaDocumentoHandler = async (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        //Setto la variabile futureState per gestire la scelta della modale
        let futureState = Protocol_State.Allocato;

        if (this.checkProtocolWizardValidity(futureState)) {

            this.setState({
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: "Vuoi generare un nuovo numero di protocollo e stampare l'etichetta?",
                },
                confirmDialogSubmitFunction: async (ev: any) => { this.allocaDocumentoConfirmDialogSubmit() }
            })
        }
    }
    allocaDocumentoConfirmDialogSubmit = async () => {

        let protocollo: IProtocol = { ...this.props.currentProtocol };

        //Forzo lo svuotamento della visibilità del protocollo
        let currentUor = { ...this.props.currentUor };
        let visibilita = [{ uor: currentUor, tipologia: Visibility_Type.Proprietario }];
        protocollo.visibilita = visibilita;

        // attendo che l'aggiornamento dello stato sia completo (richiede che il metodo chiamante sia async)
        await this.props.updateProtocolWizardState({ protocol: protocollo });

        this.setState({ confirmDialogIsOpen: false })
        this.createProtocol(Protocol_State.Allocato);
    }

    onSelectePrinter = (printerName: string) => {
        this.setState({
            selectedPrinterName: printerName
        });
    }

    reprintLabelHandler = async (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: "Vuoi stampare l'etichetta del protocollo?",
                children: <PrintLabel onSelectePrinter={this.onSelectePrinter} />

            },
            confirmDialogSubmitFunction: async (ev: any) => { this.reprintLabelConfirmDialogSubmit() }
        })

    }
    reprintLabelConfirmDialogSubmit = async () => {

        let { currentAoo, currentUor, currentProtocol } = this.props;
        let { selectedPrinterName } = this.state;

        if (currentAoo && currentUor && currentUor.id && currentProtocol && currentProtocol.id && selectedPrinterName) {
            protocolsService.getSignatureForProtocol(currentAoo.id, currentUor.id, currentProtocol.id)
                .then(signature => {
                    peripheralService.print(selectedPrinterName!, signature)
                        .catch(error => {
                            if (!error.isErrorShown) {
                                toastRef.current?.show({
                                    severity: 'error',
                                    summary: "Attenzione",
                                    detail: "Non \u00e8 stato possibile stampare l'etichetta",
                                    life: 5000
                                });
                            }
                        });


                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: "Attenzione",
                            detail: "Non \u00e8 stato possibile stampare l'etichetta",
                            life: 5000
                        });
                    }
                });

        }
        else {
            toastRef.current?.show({
                severity: 'error',
                summary: "Attenzione",
                detail: "Non \u00e8 stato possibile stampare l'etichetta",
                life: 5000
            });
        }

        this.setState({ confirmDialogIsOpen: false })
    }


    // Click sul button della commandbar
    reloadProtocolHandler = async (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (this.checkProtocolWizardValidity(this.props.currentProtocol.statoProtocollo)) {

            this.setState({
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: 'Vuoi aggiornare il protocollo?',
                },
                confirmDialogSubmitFunction: () => { this.reloadProtocolConfirmDialogSubmit() }
            })
        }
    }
    reloadProtocolConfirmDialogSubmit = () => {
        this.setState({ confirmDialogIsOpen: false })
        this.reloadProtocol();
    }




    reloadProtocol = () => {
        if (this.props.currentAoo && this.props.currentUor && this.props.currentProtocol && this.props.currentLabelInfo) {

            let { currentAoo, currentUor, currentProtocol, currentPageScaledHeight } = this.props;
            let newLabelInfo;

            this.setState({ showActionsLoader: true, shouldBlockNavigation: false });

            newLabelInfo = { ...this.props.currentLabelInfo }
            let labelScaledWidth = newLabelInfo.labelWidth * newLabelInfo.scale;
            let labelScaledHeight = newLabelInfo.labelHeight * newLabelInfo.scale;
            if (newLabelInfo.scale !== 0 && newLabelInfo.labelOrientation === LabelOrientation.Orizzontale)
                newLabelInfo.positionY = Math.round((currentPageScaledHeight - labelScaledHeight - newLabelInfo.positionY) / newLabelInfo.scale);
            else if (newLabelInfo.scale !== 0)
                newLabelInfo.positionY = Math.round((currentPageScaledHeight - labelScaledWidth - newLabelInfo.positionY) / newLabelInfo.scale);

            newLabelInfo.positionX = Math.round(newLabelInfo.positionX / newLabelInfo.scale);

            let submitProtocol = { ...currentProtocol };
            if (submitProtocol.fields) {
                let fixedFields = AppUtilities.fixFieldsInternalValueForCreateAndUpdateProtocol([...submitProtocol.fields], false);
                let touchedFields = fixedFields.filter(el => el.touched);

                submitProtocol.fields = touchedFields;
            }
            protocolsService
                .reloadProtocol(currentAoo.id, currentUor.id!, submitProtocol, newLabelInfo)
                .then(result => {
                    this.setState({ showActionsLoader: false });
                    //aggiunge gli zeri prima del numero
                    const zeroPad = (num, places) => String(num).padStart(places, '0');
                    let protocolnumber = zeroPad(submitProtocol.numeroProtocollo, 8) + '-' + submitProtocol.annoProtocollo;

                    this.props.history.push({ pathname: `/${currentAoo.id}/${submitProtocol.id}/${protocolnumber}`, search: this.props.location.search })
                },
                    error => {
                        this.setState({
                            showActionsLoader: false,
                            showMessageBar: true,
                            messageBarType: MessageBarType.error,
                            messageBarText: "Errore nell'aggiornamento del protocollo"
                        })
                    });
        }
    }

    // Click sul button della commandbar salva acquisito
    updateAcquiredHandler = async (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (this.checkProtocolWizardValidity(this.props.currentProtocol.statoProtocollo)) {

            this.setState({
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: 'Vuoi aggiornare il protocollo?',
                },
                confirmDialogSubmitFunction: () => { this.updateAcquiredConfirmDialogSubmit() }
            })
        }
    }
    updateAcquiredConfirmDialogSubmit = () => {
        this.setState({ confirmDialogIsOpen: false })
        this.updateAcquired();
    }

    updateAcquired = () => {
        if (this.props.currentAoo && this.props.currentUor && this.props.currentProtocol) {

            let { currentAoo, currentUor, currentProtocol, currentPageScaledHeight } = this.props;
            let newLabelInfo;

            this.setState({ showActionsLoader: true, shouldBlockNavigation: false });
            if (this.props.currentLabelInfo) {
                newLabelInfo = { ...this.props.currentLabelInfo }
                let labelScaledWidth = newLabelInfo.labelWidth * newLabelInfo.scale;
                let labelScaledHeight = newLabelInfo.labelHeight * newLabelInfo.scale;
                if (newLabelInfo.scale !== 0 && newLabelInfo.labelOrientation === LabelOrientation.Orizzontale)
                    newLabelInfo.positionY = Math.round((currentPageScaledHeight - labelScaledHeight - newLabelInfo.positionY) / newLabelInfo.scale);
                else if (newLabelInfo.scale !== 0)
                    newLabelInfo.positionY = Math.round((currentPageScaledHeight - labelScaledWidth - newLabelInfo.positionY) / newLabelInfo.scale);

                newLabelInfo.positionX = Math.round(newLabelInfo.positionX / newLabelInfo.scale);
            }
            let submitProtocol = { ...currentProtocol };
            if (submitProtocol.fields) {
                let fixedFields = AppUtilities.fixFieldsInternalValueForCreateAndUpdateProtocol([...submitProtocol.fields], false);
                let touchedFields = fixedFields.filter(el => el.touched);

                submitProtocol.fields = touchedFields;
            }
            protocolsService
                .updateAcquired(currentAoo.id, currentUor.id!, submitProtocol, newLabelInfo)
                .then(result => {
                    this.setState({ showActionsLoader: false });
                    //aggiunge gli zeri prima del numero
                    const zeroPad = (num, places) => String(num).padStart(places, '0');
                    let protocolnumber = zeroPad(submitProtocol.numeroProtocollo, 8) + '-' + submitProtocol.annoProtocollo;

                    this.props.history.push({ pathname: `/${currentAoo.id}/${submitProtocol.id}/${protocolnumber}`, search: this.props.location.search })
                },
                    error => {
                        this.setState({
                            showActionsLoader: false,
                            showMessageBar: true,
                            messageBarType: MessageBarType.error,
                            messageBarText: "Errore nell'aggiornamento del protocollo"
                        })
                    });
        }
    }




    dismissSelectUorDialog = () => {
        this.props.history.push({ pathname: `/${this.props.currentAoo!.id}` });
        this.props.updateSession({ currentUor: undefined });

        this.setState({ selectUorDialogIsOpen: false })
    }
    onSelectUorConfirmDialogSubmit = () => {
        let { url } = this.props.match;
        let uorId = this.choiceGroupRef.current?.checkedOption!['uorId'];
        const parsedQueryString = queryString.parse(this.props.location.search);
        parsedQueryString.uorId = uorId;
        const newQueryString = queryString.stringify(parsedQueryString);


        this.props.history.replace({ pathname: url, search: newQueryString });
        this.setState({ selectUorDialogIsOpen: false });

    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }

    dismissSetVisibilitaDialog = () => {
        let currentUor = { ...this.props.currentUor };
        let visibilita = [{ uor: currentUor, tipologia: Visibility_Type.Proprietario }];
        this.props.setProtocol({ visibilita: visibilita });

        this.setState({ setVisibilitaDialogIsOpen: false })
    }

    createProtocol = (submitStateProtocol: Protocol_State) => {
        if (this.props.currentAoo && this.props.currentUor && this.props.currentProtocol /*&& this.props.currentLabelInfo*/) {

            let { currentAoo, currentUor, currentProtocol, currentLabelInfo, currentPageScaledHeight } = this.props;
            let newLabelInfo;

            this.setState({ showActionsLoader: true, shouldBlockNavigation: false });
            if (this.props.currentLabelInfo) {
                newLabelInfo = { ...currentLabelInfo };
                let labelScaledWidth = newLabelInfo.labelWidth * newLabelInfo.scale;
                let labelScaledHeight = newLabelInfo.labelHeight * newLabelInfo.scale;
                if (newLabelInfo.scale !== 0 && newLabelInfo.labelOrientation === LabelOrientation.Orizzontale)
                    newLabelInfo.positionY = Math.round((currentPageScaledHeight - labelScaledHeight - newLabelInfo.positionY) / newLabelInfo.scale);
                else if (newLabelInfo.scale !== 0)
                    newLabelInfo.positionY = Math.round((currentPageScaledHeight - labelScaledWidth - newLabelInfo.positionY) / newLabelInfo.scale);

                newLabelInfo.positionX = Math.round(newLabelInfo.positionX / newLabelInfo.scale);
            }

            let submitProtocol = { ...currentProtocol };
            submitProtocol.statoProtocollo = submitStateProtocol;
            if (submitProtocol.fields) {
                let fixedFields = AppUtilities.fixFieldsInternalValueForCreateAndUpdateProtocol([...submitProtocol.fields], true);
                submitProtocol.fields = fixedFields;
            }
            let { wizardMode } = this.props.currentProtocolWizardState;
            let createProtocol;
            switch (wizardMode) {
                case Wizard_Mode.Create:
                case Wizard_Mode.CreateFrom:
                    createProtocol = protocolsService.createProtocol(currentAoo.id, currentUor.id!, submitProtocol, newLabelInfo);
                    break;
                case Wizard_Mode.Acquired:
                    createProtocol = protocolsService.protocollaAcquired(currentAoo.id, currentUor.id!, submitProtocol, newLabelInfo);
                    break;
                case Wizard_Mode.Allocated:
                    createProtocol = protocolsService.protocollaOAcquisisciAllocato(currentAoo.id, currentUor.id!, submitProtocol);
                    break;
                case Wizard_Mode.Edit:
                    createProtocol = protocolsService.createProtocolFromDraft(currentAoo.id, currentUor.id!, submitProtocol, newLabelInfo);
                    break;
                case Wizard_Mode.PrintLabel:
                    createProtocol = protocolsService.createAllocatedProtocol(currentAoo.id, currentUor.id!, submitProtocol);
                    break;
            }

            createProtocol
                .then(result => {
                    this.setState({ showActionsLoader: false, shouldBlockNavigation: false });
                    this.props.setProtocol({ statoProtocollo: submitProtocol.statoProtocollo });
                    switch (submitProtocol.statoProtocollo) {
                        case Protocol_State.Allocato:
                            /// nel caso del createAllocatedProtocol, il result è un object contenente l'id del protocollo e signatureAX
                            let numeroProtocollo: string = result.signature.numeroProtocollo;
                            numeroProtocollo = numeroProtocollo.replace("/", "-");
                            this.props.history.push({ pathname: `/${currentAoo.id}/allocated/${result.protocolId}/${numeroProtocollo}`, search: this.props.location.search });


                            if (this.props.currentProtocolWizardState.selectedPrinterName) {
                                peripheralService.print(this.props.currentProtocolWizardState.selectedPrinterName, result.signature)
                                    .catch(error => {
                                        if (!error.isErrorShown) {
                                            toastRef.current?.show({
                                                severity: 'error',
                                                summary: "Attenzione",
                                                detail: "Non \u00e8 stato possibile stampare l'etichetta",
                                                life: 5000
                                            });
                                        }
                                    });
                            }
                            else {
                                toastRef.current?.show({
                                    severity: 'error',
                                    summary: "Attenzione",
                                    detail: "Non \u00e8 stato possibile stampare l'etichetta",
                                    life: 5000
                                });
                            }
                            break;
                        default:
                            this.props.history.push({ pathname: `/${currentAoo.id} `, search: this.props.location.search });

                            break;
                    }
                },
                    error => {
                        this.setState({
                            showActionsLoader: false,
                            showMessageBar: true,
                            messageBarType: MessageBarType.error,
                            messageBarText: 'Errore nella creazione del protocollo'
                        })
                    });
        }
    }
    updateDraft = () => {
        if (this.props.currentAoo && this.props.currentUor && this.props.currentProtocol) {

            let { currentAoo, currentUor, currentProtocol } = this.props;
            this.setState({ showActionsLoader: true, shouldBlockNavigation: false });

            let submitProtocol = { ...currentProtocol };
            if (submitProtocol.fields) {
                let fixedFields = AppUtilities.fixFieldsInternalValueForCreateAndUpdateProtocol([...submitProtocol.fields], true);
                submitProtocol.fields = fixedFields;
            }
            //Modifico la bozza e aggiorno il documento pricipale al document set

            protocolsService
                .updateProtocolDraft(currentAoo.id, currentUor.id!, currentProtocol.id!, submitProtocol)
                .then(result => {
                    this.setState({ showActionsLoader: false });
                    this.props.history.push({ pathname: `/ ${currentAoo.id} /drafts`, search: this.props.location.search })
                },
                    error => {
                        this.setState({
                            showActionsLoader: false,
                            showMessageBar: true,
                            messageBarType: MessageBarType.error,
                            messageBarText: 'Errore nell\' aggiornamento del protocollo'
                        })
                    });

        }
    }

    createDraft = () => {
        if (this.props.currentAoo && this.props.currentUor && this.props.currentProtocol) {

            let { currentAoo, currentUor, currentProtocol } = this.props;

            this.setState({ showActionsLoader: true, shouldBlockNavigation: false });


            let submitProtocol = { ...currentProtocol };
            if (submitProtocol.fields) {
                let fixedFields = AppUtilities.fixFieldsInternalValueForCreateAndUpdateProtocol([...submitProtocol.fields], true);
                submitProtocol.fields = fixedFields;
            }
            protocolsService
                .createDraft(currentAoo.id, currentUor.id!, submitProtocol)
                .then(result => {
                    this.setState({ showActionsLoader: false });
                    this.props.history.push({ pathname: `/${currentAoo.id}/drafts`, search: this.props.location.search })
                },
                    error => {
                        this.setState({
                            showActionsLoader: false,
                            showMessageBar: true,
                            messageBarType: MessageBarType.error,
                            messageBarText: 'Errore nella creazione del protocollo'
                        })
                    });
        }
    }

    setDocumentFile = (fileResult: IFile, newProtocol: IProtocol) => {
        let convertFile: boolean = false;
        if (fileResult && fileResult.docBase64String && fileResult.extension !== '.pdf' && AppUtilities.extensionsAllowedForProtocolDocument.findIndex(el => el.toLowerCase() === fileResult.extension?.toLowerCase()) >= 0) {
            convertFile = true;
        }

        let documentFile: IFile = {
            ...fileResult,
            dimensionUnit: newProtocol.documentFile?.dimensionUnit,
            dimension: newProtocol.documentFile?.dimension,
            loading: convertFile,
            enabled: true,
        };

        if (convertFile) {
            filesService.convertToPdf(documentFile)
                .then(result => {
                    let newDocumentFile: IFile = { ...documentFile, docBase64String: result, loading: false };
                    this.props.setDocumentFile(newDocumentFile);

                });
        }
        else {
            let newDocumentFile: IFile = { ...documentFile };
            this.props.setDocumentFile(newDocumentFile);

        }
    }


    updateCommandBarItems(wizardMode: Wizard_Mode) {

        let newCommandBarItems: ICommandBarItemProps[] = [];
        if (wizardMode !== Wizard_Mode.Reload && wizardMode !== Wizard_Mode.PrintLabel
            && abilityBuild.can('use', subject('IFeature', { key: 'Drafts', enabled: true }))
            && this.props.currentProtocol.statoProtocollo !== Protocol_State.Acquisito
            && this.props.currentProtocol.statoProtocollo !== Protocol_State.Allocato) {
            newCommandBarItems.push({
                key: 'salva',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Salva bozza'
                        key='salva'
                        iconPropsFontAwesome={{ icon: ['fal', 'file-signature'] }}
                        onClick={this.salvaBozzaHandler}
                    />
                )
            });
        }

        if (wizardMode === Wizard_Mode.Edit
            && abilityBuild.can('use', subject('IFeature', { key: 'Drafts', enabled: true }))
            && (this.props.currentProtocol.statoProtocollo === Protocol_State.InCreazione
                || this.props.currentProtocol.statoProtocollo === Protocol_State.InCreazioneDaMail)) {
            newCommandBarItems.push({
                key: 'elimina',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Elimina bozza'
                        key='elimina'
                        iconPropsFontAwesome={{ icon: ['fal', 'trash-can'] }}
                        onClick={this.deleteDraftHandler}
                    />
                )
            });
        }

        if (wizardMode !== Wizard_Mode.Reload && wizardMode !== Wizard_Mode.PrintLabel
            && abilityBuild.cannot('use', subject('IFeature', { key: 'SingleStepProtocol', enabled: true }))
            && this.props.currentProtocol.statoProtocollo !== Protocol_State.Acquisito) {
            newCommandBarItems.push({
                key: 'acquisisci',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Acquisisci'
                        key='acquisisci'
                        iconPropsFontAwesome={{ icon: ['fal', 'file-check'] }}
                        onClick={this.acquisisciDocumentoHandler}
                    />
                )
            });
        }

        if (wizardMode === Wizard_Mode.Acquired) {
            newCommandBarItems.push(...[

                {
                    key: 'saveAcquiredProtocol',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            text='Salva'
                            key='saveAcquiredProtocol'
                            iconPropsFontAwesome={{ icon: ['fal', 'file-signature'] }}
                            onClick={this.updateAcquiredHandler}
                        />
                    )
                },
            ]);
        }

        if (wizardMode !== Wizard_Mode.Reload && wizardMode !== Wizard_Mode.PrintLabel) {
            newCommandBarItems.push(...[
                {
                    key: 'protocolla',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            text='Protocolla'
                            key='protocolla'
                            iconPropsFontAwesome={{ icon: ['fal', 'file-certificate'] }}
                            onClick={this.protocollaDocumentoHandler}
                        />
                    )
                },
            ]);
        }
        if (wizardMode === Wizard_Mode.Reload) {
            newCommandBarItems.push(...[

                {
                    key: 'reloadProtocol',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            text='Aggiorna protocollo'
                            key='reloadProtocol'
                            iconPropsFontAwesome={{ icon: ['fal', 'file-check'] }}
                            onClick={this.reloadProtocolHandler}
                        />
                    )
                },
            ]);
        }

        if (wizardMode === Wizard_Mode.PrintLabel
            && abilityBuild.can('use', subject('IFeature', { key: 'StampaEtichetta', enabled: true }))) {
            newCommandBarItems.push(...[
                {
                    key: 'printLabel',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            text='Stampa etichetta'
                            key='printLabel'
                            iconProps={{ iconName: 'QRCode' }}
                            onClick={this.allocaDocumentoHandler}
                        />
                    )
                }
            ]);
        }
        if ((wizardMode === Wizard_Mode.Allocated || wizardMode === Wizard_Mode.Acquired)
            && abilityBuild.can('use', subject('IFeature', { key: 'StampaEtichetta', enabled: true }))
        ) {
            newCommandBarItems.push(...[
                {
                    key: 'reprintLabel',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            text='Stampa etichetta'
                            key='reprintLabel'
                            iconProps={{ iconName: 'QRCode' }}
                            onClick={this.reprintLabelHandler}
                        />
                    )
                }
            ]);
        }
        this.setState({ commandBarItems: newCommandBarItems });
    }

    onForwardButtonClick = () => {
        if (this.props.stepIndex < this.state.stepItems.length - 1) {
            this.props.nextStepIndex();
        }
    }
    onBackButtonClick = () => {
        if (this.props.stepIndex > 0) {
            this.props.previousStepIndex();
        }
    }
    onStepIndexClick = (index: number) => {
        this.props.setStepIndex(index)
    }

    documentTypeChangeHandler = (ev, option) => {
        let enumString: string = option.key;
        let protocolType: Protocol_Type = Protocol_Type[enumString];
        let currentProtocolFields = [...this.props.currentProtocol.fields ?? []];
        let docInFields = [...this.props.docInFields ?? []];
        let docOutFields = [...this.props.docOutFields ?? []];
        let docInternalFields = [...this.props.docInternalFields ?? []];
        let wizardMode = this.props.currentProtocolWizardState.wizardMode;
        this.setState({
            showIndiciLoader: true,
        }, () => {
            ////////////////// Ricavo i fields degli indici in base al tipo di documento solo se non li ho già 
            switch (protocolType) {
                case Protocol_Type.DocumentoInEntrata:
                    if (this.props.currentAoo && this.props.currentUor && (!docInFields || docInFields.length === 0)) {
                        fieldsService.getFieldsByType(this.props.currentAoo.id, this.props.currentUor.id!, protocolType)
                            .then(fields => {
                                let titolarioField = fields?.find(el => el.internalName === 'Titolario');
                                let _fields = AppUtilities.FilterAndFixFieldsByWizardMode(wizardMode, fields!);
                                const allFields: IField[] = Array.from(
                                    new Set([...currentProtocolFields, ...docInFields, ...docOutFields, ...docInternalFields].map(obj => JSON.stringify(obj)))
                                ).map(str => JSON.parse(str));

                                _fields = _fields.map(fieldEl => {
                                    let field = allFields.find(el => el.internalName === fieldEl.internalName);
                                    if (field) {
                                        return field;
                                    }
                                    else {
                                        return fieldEl;
                                    }
                                });
                                this.props.updateProtocolWizardState(
                                    {
                                        protocol: { ...this.props.currentProtocol, tipoProtocollo: protocolType, fields: _fields },
                                        docInFields: _fields,
                                    });
                                if (titolarioField) {
                                    this.setState({ showIndiciLoader: false, titolarioRequired: titolarioField?.required, titolarioTouched: false })
                                } else {
                                    this.setState({ showIndiciLoader: false, titolarioRequired: false, titolarioTouched: false })
                                }

                            })

                    }
                    else if (this.props.currentAoo && this.props.currentUor && docInFields && docInFields.length > 0) {
                        this.props.updateProtocolWizardState(
                            {
                                protocol: { ...this.props.currentProtocol, tipoProtocollo: protocolType, fields: docInFields },
                            });

                        setTimeout(() => {
                            this.setState({ showIndiciLoader: false });
                        }, 200);
                    }
                    break;
                case Protocol_Type.DocumentoInUscita:
                    if (this.props.currentAoo && this.props.currentUor && (!docOutFields || docOutFields.length === 0)) {
                        fieldsService.getFieldsByType(this.props.currentAoo.id, this.props.currentUor.id!, protocolType)
                            .then(fields => {
                                let titolarioField = fields?.find(el => el.internalName === 'Titolario');
                                let _fields = AppUtilities.FilterAndFixFieldsByWizardMode(wizardMode, fields!);

                                const allFields: IField[] = Array.from(
                                    new Set([...currentProtocolFields, ...docInFields, ...docOutFields, ...docInternalFields].map(obj => JSON.stringify(obj)))
                                ).map(str => JSON.parse(str));

                                _fields = _fields.map(fieldEl => {
                                    let field = allFields.find(el => el.internalName === fieldEl.internalName);
                                    if (field) {
                                        return field;
                                    }
                                    else {
                                        return fieldEl;
                                    }
                                });

                                this.props.updateProtocolWizardState(
                                    {
                                        protocol: { ...this.props.currentProtocol, tipoProtocollo: protocolType, fields: _fields },
                                        docOutFields: _fields,
                                    });

                                if (titolarioField) {
                                    this.setState({ showIndiciLoader: false, titolarioRequired: titolarioField?.required, titolarioTouched: false })
                                } else {
                                    this.setState({ showIndiciLoader: false, titolarioRequired: false, titolarioTouched: false })
                                }


                            })
                    }
                    else if (this.props.currentAoo && this.props.currentUor && docOutFields && docOutFields.length > 0) {
                        this.props.updateProtocolWizardState(
                            {
                                protocol: { ...this.props.currentProtocol, tipoProtocollo: protocolType, fields: docOutFields },
                            });

                        setTimeout(() => {
                            this.setState({ showIndiciLoader: false });
                        }, 200);
                    }

                    break;
                case Protocol_Type.DocumentoInterno:
                    if (this.props.currentAoo && this.props.currentUor && (!docInternalFields || docInternalFields.length === 0)) {
                        fieldsService.getFieldsByType(this.props.currentAoo.id, this.props.currentUor.id!, protocolType)
                            .then(fields => {
                                let titolarioField = fields?.find(el => el.internalName === 'Titolario');
                                let _fields = AppUtilities.FilterAndFixFieldsByWizardMode(wizardMode, fields!);
                                const allFields: IField[] = Array.from(
                                    new Set([...currentProtocolFields, ...docInFields, ...docOutFields, ...docInternalFields].map(obj => JSON.stringify(obj)))
                                ).map(str => JSON.parse(str));

                                _fields = _fields.map(fieldEl => {
                                    let field = allFields.find(el => el.internalName === fieldEl.internalName);
                                    if (field) {
                                        return field;
                                    }
                                    else {
                                        return fieldEl;
                                    }
                                });

                                this.props.updateProtocolWizardState(
                                    {
                                        protocol: { ...this.props.currentProtocol, tipoProtocollo: protocolType, fields: _fields },
                                        docInternalFields: _fields,
                                    });

                                if (titolarioField) {
                                    this.setState({ showIndiciLoader: false, titolarioRequired: titolarioField?.required, titolarioTouched: false })
                                } else {
                                    this.setState({ showIndiciLoader: false, titolarioRequired: false, titolarioTouched: false })
                                }


                            })
                    }
                    else if (this.props.currentAoo && this.props.currentUor && docInternalFields && docInternalFields.length > 0) {
                        this.props.updateProtocolWizardState(
                            {
                                protocol: { ...this.props.currentProtocol, tipoProtocollo: protocolType, fields: docInternalFields },
                            });

                        setTimeout(() => {
                            this.setState({ showIndiciLoader: false });
                        }, 200);
                    }

                    break;

            }
        });

        ////////////////
    }


    onDocumentoFileChanged = () => {
        let { wizardMode } = this.props.currentProtocolWizardState;

        if (wizardMode !== Wizard_Mode.Allocated) {
            this.setState({ isDocumentChanged: true, stepItems: generalProtocolSteps });
            this.props.updateProtocolWizardState({ labelInfo: undefined });
        }
    }

    checkProtocolWizardValidity = (targetState): boolean => {
        let isValid = true;

        let errors = {};

        const currentProtocolWizardState: ProtocolWizardReduxState = {
            ...this.props.currentProtocolWizardState
        }

        let { protocol, labelInfo, selectedPrinterName, documentScannerLoader, attachmentScannerLoader } = currentProtocolWizardState;


        if (documentScannerLoader) {
            isValid = false;
            errors["document"] = "attendere il caricamento del documento";
        }
        else if (targetState === Protocol_State.Allocato && !selectedPrinterName) {
            isValid = false;
            errors["document"] = "selezionare una stampante";
        }
        else if ((targetState === Protocol_State.Acquisito || targetState === Protocol_State.Protocollato)
            && protocol && !protocol.documentFile) {
            isValid = false;
            errors["document"] = "selezionare un documento";
        }

        if (attachmentScannerLoader) {
            isValid = false;
            errors["attachment"] = "attendere il caricamento dell'allegato";
        }

        if (protocol && protocol.tipoProtocollo === Protocol_Type.Undefined) {
            isValid = false;
            errors["type"] = "selezionare il Tipo di documento";
        }

        // ho bisogno di selezionare un titolario e compilare gli indici se 
        if ((targetState === Protocol_State.Protocollato && protocol && protocol.fields)
            // e se il targetState è Allocato quando
            || (targetState === Protocol_State.Allocato && protocol && protocol.fields
                // il wizardMode è PrintLabel 
                && currentProtocolWizardState.wizardMode === Wizard_Mode.PrintLabel
                // ed è attivo singleStepProtocol
                && abilityBuild.can('use', subject('IFeature', { key: 'SingleStepProtocol', enabled: true })))) {

            const updatedProtocolFields: IField[] = [];

            let titolarioValidity = AppUtilities.checkTitolarioFieldValidity(this.state.titolarioRequired, this.props.currentProtocol!.titolario)

            if (!titolarioValidity) {
                isValid = false;
                errors["filingPlan"] = "selezionare una voce di Titolario";
            }
            this.setState({
                titolarioTouched: true,
                titolarioValid: titolarioValidity
            });

            protocol.fields.forEach((item) => {

                let fieldValidity = AppUtilities.checkFieldValidity(item)
                if (!fieldValidity) {
                    isValid = false;
                    errors["indexes"] = "compilare correttamente gli Indici";
                }

                updatedProtocolFields.push({
                    ...item,
                    touched: true,
                    valid: fieldValidity
                })


            })
            protocol.fields = updatedProtocolFields;


        }

        // in fase di acquisizione o protocollazione è necessario applicare l'etichetta se 
        if (
            (targetState === Protocol_State.Acquisito || targetState === Protocol_State.Protocollato)
            && (
                // sto lavorando un acquisito e ho cambiato il documento 
                ((protocol.statoProtocollo === Protocol_State.Acquisito && this.state.isDocumentChanged && !labelInfo)
                    ||
                    // oppure sto lavorando una bozza 
                    (protocol.statoProtocollo !== Protocol_State.Acquisito && !labelInfo))
                &&
                // oppure se non sto lavorando un allocato
                (protocol.statoProtocollo !== Protocol_State.Allocato)
            )
        ) {

            isValid = false;
            errors["label"] = "posizionare l'etichetta";
        }
        currentProtocolWizardState.valid = isValid;
        currentProtocolWizardState.touched = true;

        this.props.updateProtocolWizardState({
            ...currentProtocolWizardState,
            valid: isValid,
            touched: true,
            labelInfo: labelInfo,
            protocol: protocol
        });

        let errorMessage = AppUtilities.getMessageFromErrorObjectValidity(errors);
        this.setState({ showMessageBar: !isValid, messageBarType: MessageBarType.error, messageBarText: errorMessage })
        return isValid;
    }



    indiciInputChangedHandler = (newField: IField) => {

        const updatedProtocolFields = [...(this.props.currentProtocol.fields ?? [])];
        let itemIndex = updatedProtocolFields.findIndex(el => el.internalName === newField.internalName);
        updatedProtocolFields[itemIndex] = { ...newField };


        const updatedDocInFields = [...(this.props.docInFields ?? [])];
        itemIndex = updatedDocInFields.findIndex(el => el.internalName === newField.internalName);
        updatedDocInFields[itemIndex] = { ...newField };

        const updatedDocOutFields = [...(this.props.docOutFields ?? [])];
        itemIndex = updatedDocOutFields.findIndex(el => el.internalName === newField.internalName);
        updatedDocOutFields[itemIndex] = { ...newField };

        const updatedDocInternalFields = [...(this.props.docInternalFields ?? [])];
        itemIndex = updatedDocInternalFields.findIndex(el => el.internalName === newField.internalName);
        updatedDocInternalFields[itemIndex] = { ...newField };

        this.props.updateProtocolWizardState(
            {
                protocol: { ...this.props.currentProtocol, fields: updatedProtocolFields },
                docInFields: updatedDocInFields,
                docOutFields: updatedDocOutFields,
                docInternalFields: updatedDocInternalFields,
                touched: true
            });

    }


    onSelectFilingPlanKeyHandler = (selectedKey) => {

        this.props.setProtocol({ titolario: selectedKey });
        if (selectedKey) {
            this.setState({
                titolarioTouched: true,
                titolarioValid: true
            });
        } else {
            this.setState({
                titolarioTouched: true,
                titolarioValid: false
            });
        }
    }

    onDocumentoFileSourceChange = (newValue) => {
        let _wizardMode = this.getProtocolWizardMode();
        if (newValue === "stampaEtichetta") {
            _wizardMode = Wizard_Mode.PrintLabel;
            this.setState({
                stepItems: [...acquiredProtocolSteps]
            });

        } else if (newValue === "stampaEtichetta"
            && abilityBuild.can('use', subject('IFeature', { key: 'SingleStepProtocol', enabled: true }))) {
            _wizardMode = Wizard_Mode.PrintLabel;
            this.setState({
                stepItems: [...acquiredProtocolSteps]
            });
        } else {
            this.setState({
                stepItems: [...generalProtocolSteps]
            });
        }
        this.props.updateProtocolWizardState({ wizardMode: _wizardMode });

        this.updateCommandBarItems(_wizardMode);
    };

    stepElement = () => {
        let { wizardMode } = this.props.currentProtocolWizardState;
        let showAttachementsUpload = wizardMode !== Wizard_Mode.Reload;
        let showDocumentoFilesList = wizardMode !== Wizard_Mode.PrintLabel;
        switch (this.props.stepIndex) {
            case 0:
                return (
                    <React.Fragment>

                        <div className={"col-12 lg:col-6 xl:col-4 flex flex-column p-as-start box-wrapper"}>
                            <div className='box'>

                                <div className={`position-relative my-scroll-div`}>
                                    <div className={'box-content'}>
                                        <Label>Documento</Label>
                                        <UploadFiles key='upload_file_documento' target='documento' onFileChanged={this.onDocumentoFileChanged} onFileSourceChange={this.onDocumentoFileSourceChange} />
                                    </div>
                                    {showDocumentoFilesList &&
                                        <div className={'box-content'} style={{ paddingTop: "0" }}>
                                            <FilesList target='documento' {...this.props} />
                                        </div>
                                    }
                                </div>

                            </div>
                        </div>
                        {showAttachementsUpload &&

                            <div className={"col-12 lg:col-6 xl:col-4 flex flex-column p-as-start box-wrapper"}>
                                <div className='box'>

                                    <div className={`position-relative my-scroll-div`}>
                                        <div className={'box-content'}>
                                            <Label>Allegati</Label>
                                            <UploadFiles key='upload_files_allegati' target='allegati' />
                                        </div>
                                        <div className={'box-content'} style={{ paddingTop: "0" }}>
                                            <FilesList target='allegati' {...this.props} />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        }

                    </React.Fragment>

                );
            case 1:
                //let fixedFields;
                //let indiciMode = wizardMode !== Wizard_Mode.Acquired ? Indici_FormMode.Create : Indici_FormMode.Edit;
                //if (this.props.currentProtocol && this.props.currentProtocol.fields && this.props.currentProtocol.tipoProtocollo) {
                //    fixedFields = AppUtilities.fixFieldsForm(indiciMode, this.props.currentProtocol.fields);
                //}

                let protocolTypeString = Protocol_Type[this.props.currentProtocol.tipoProtocollo ?? 0];
                let disableChoiceTipoDocumento = wizardMode === Wizard_Mode.CreateFrom;
                let showTitolarioField = this.props.currentProtocol.tipoProtocollo !== Protocol_Type.Undefined;

                return (
                    <React.Fragment>
                        <div className={"col-12 lg:col-6 xl:col-4 flex flex-column box-wrapper"}>
                            <div className='box position-relative' style={{ minHeight: '300px' }} >
                                <CircleLoader loaderClass='loader-large' loading={this.state.showIndiciLoader} />
                                <div className={`position-relative my-scroll-div`}>
                                    <div className={'flex flex-column position-relative'}>
                                        <div className={'box-content'}>
                                            {wizardMode !== Wizard_Mode.Acquired &&
                                                <ChoiceGroup
                                                    label="Tipo di documento:"
                                                    selectedKey={protocolTypeString}
                                                    options={this.state.documentTypeOptions}
                                                    onChange={(ev, option) => this.documentTypeChangeHandler(ev, option)}
                                                    disabled={disableChoiceTipoDocumento}
                                                />
                                            }

                                            <DynamicForm
                                                fields={this.props.currentProtocol.fields}
                                                extraCssClass=""
                                                onInputChangedHandler={(newField) => { this.indiciInputChangedHandler(newField) }}
                                            />
                                            {showTitolarioField &&
                                                <div className={this.state.titolarioTouched && !this.state.titolarioValid ? 'titolario field error' : 'titolario field'} >
                                                    <Label className='field-label' htmlFor={"Titolario"} required={this.state.titolarioRequired}>Titolario</Label>
                                                    {this.state.titolarioTouched && !this.state.titolarioValid && <span className="error-message">Campo obbligatorio</span>}
                                                    <FilingPlanTree
                                                        key={"Titolario"}
                                                        readOnlyMode={false}
                                                        selectedFilingPlanKey={this.props.currentProtocol.titolario ? this.props.currentProtocol.titolario : undefined}
                                                        onSelectFilingPlanKeyHandler={(selected) => this.onSelectFilingPlanKeyHandler(selected)}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"col-12 lg:col-6 xl:col-8 flex flex-column box-wrapper"}>
                            <div className='box position-relative' style={{ minHeight: '300px' }} >
                                <div className={`position-relative my-scroll-div`}>
                                    <div className={'box-content'}>

                                        <PdfViewer base64String={this.props.currentProtocol.documentFile?.docBase64String} initialLoading={false} />

                                    </div>
                                </div>
                            </div>
                        </div>

                    </React.Fragment>

                );

                break;

            case 2:
                if (this.props.currentProtocol) {
                    return (
                        <React.Fragment>
                            <div id='doc-container' className="document-wrapper position-relative col-12">
                                <div className={`position-relative my-scroll-div`}>
                                    <LabelPosition base64String={this.props.currentProtocol.documentFile?.docBase64String} />
                                </div>

                            </div>
                        </React.Fragment>
                    );

                }
                break;

        }
    }
    render() {


        return (
            <React.Fragment>
                <div className={`loader opacity ${this.state.showActionsLoader ? "active" : ''}`}>
                    <RippleLoader text='Creazione protocollo' />
                </div>

                <div className='protocol-wizard-component flex flex-column p-nogutter  position-relative'>
                    <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingProtocol} />

                    <Prompt
                        when={this.state.shouldBlockNavigation}
                        message='Le modifiche apportate potrebbero non essere salvate, vuoi lasciare la pagina?'
                    />
                    <CommandBar
                        items={this.state.commandBarItems}
                        overflowButtonProps={overflowProps}
                        farItems={this.state.farItems}
                        styles={commandBarStyles}
                    />

                    {
                        this.state.showMessageBar &&
                        <MessageBar
                            messageBarType={this.state.messageBarType}
                            isMultiline={false}
                            onDismiss={() => this.setState({ showMessageBar: false })}
                            dismissButtonAriaLabel="Close">{this.state.messageBarText}</MessageBar>
                    }

                    <Steps model={this.state.stepItems} activeIndex={this.props.stepIndex} onSelect={(e) => this.onStepIndexClick(e.index)} readOnly={false} />

                    <div className="flex flex-column lg:flex-row p-nogutter step-content">
                        {this.stepElement()}

                    </div>
                    <Dialog
                        hidden={!this.state.confirmDialogIsOpen}
                        onDismiss={this.dismissConfirmDialog}
                        modalProps={this.state.confirmDialogModalProps}
                        dialogContentProps={this.state.confirmDialogContentProps}>
                        {this.state.confirmDialogContentProps.children &&
                            this.state.confirmDialogContentProps.children
                        }
                        <DialogFooter>
                            <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                            <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />

                        </DialogFooter>

                    </Dialog>

                    <Dialog
                        hidden={!this.state.setVisibilitaDialogIsOpen}
                        onDismiss={this.dismissSetVisibilitaDialog}
                        dialogContentProps={this.state.setVisibilitaDialogContentProps}
                        modalProps={visibilitaModalProps}
                    >

                        <div style={{ overflow: "hidden", height: "100%", minHeight: "100px" }}>
                            <Visibilita
                                visibilita={this.props.currentProtocol!.visibilita}
                                onUpdateVisibilitaHandler={
                                    (visibilita) => {
                                        this.props.setProtocol({ visibilita: visibilita });
                                        this.props.setProtocolWizardTouched();
                                    }
                                }
                                viewMode={Visibilita_ViewMode.Expanded}
                            />
                        </div>

                        <DialogFooter>
                            <PrimaryButton id="confermaVisibilitaId" onClick={() => this.state.setVisibilitaDialogSubmitFunction()} text="Conferma" />
                        </DialogFooter>
                    </Dialog>


                    <Dialog
                        hidden={!this.state.selectUorDialogIsOpen}
                        onDismiss={this.dismissSelectUorDialog}
                        dialogContentProps={this.state.selectUorDialogContentProps}
                        modalProps={modalProps}

                    >
                        <div className={`position-relative my-scroll-div`}>

                            <ChoiceGroup
                                componentRef={this.choiceGroupRef}

                                defaultSelectedKey={'0'}
                                options={this.state.selectUorChoiceGroupOptions}
                            />
                        </div>

                        <DialogFooter>
                            <PrimaryButton
                                onClick={this.onSelectUorConfirmDialogSubmit}
                                text="Conferma"
                            />
                            <DefaultButton onClick={this.dismissSelectUorDialog} text="Annulla" />
                        </DialogFooter>
                    </Dialog>
                </div>
            </React.Fragment>

        );
    }
}

export default connector(withRouter(checkRoles(ProtocolWizard, RoleContext.Uor)));


